import type { RouteConfig } from 'vue-router';

export default [
  /**
   * 银行卡列表
   * 目前用于 借款/还款/更换划扣卡/宜享花APP银行卡中心
   */
  {
    path: '/bankcard',
    meta: {
      customNavBar: true,
      title: '银行卡列表',
      background: '#f5f6fa',
    },
    component: () => import('@/views/bankcard/index.vue'),
  },
  /**
   * 宜享花APP银行卡中心
   * 目前仅用于宜享花APP
   */
  {
    path: '/bankcard/center',
    meta: {
      title: '银行卡中心',
      background: '#f2f5ff',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/bankcard/center.vue'),
  },
  /**
   * 添加银行卡
   * 目前用于 银行卡列表/借款/还款/宜享花APP银行卡中心
   */
  {
    path: '/bankcard/add',
    meta: {
      title: '添加银行卡',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/bankcard/add.vue'),
  },
  /**
   * 银行卡支行
   * 目前用于 银行卡列表/添加银行卡/借款/还款
   */
  {
    path: '/bankcard/:cardId/sub-branch',
    meta: {
      title: '银行卡支行',
    },
    component: () => import('@/views/bankcard/sub-branch.vue'),
  },
  /**
   * 开通协议支付
   * 只能从支行页进入
   */
  {
    path: '/bankcard/:cardId/agreement-pay',
    meta: {
      title: '开通协议支付',
      excludeTracking: true,
      customNavBar: true,
    },
    component: () => import('@/views/bankcard/agreement-pay.vue'),
  },
  /**
   * 一键绑卡成功回调地址
   */
  {
    path: '/bankcard/bind/result',
    meta: {
      background: '#fff',
      customNavBar: true,
      excludeLogin: true,
      excludeTracking: true,
    },
    component: () => import('@/views/bankcard/quick-bind-bankcard-result.vue'),
  },
  /**
   * 宜享花APP银行卡详情页
   * 目前仅用于宜享花APP-变更银行卡预留手机号及解绑银行卡
   */
  {
    path: '/bankcard/:cardId/detail',
    meta: {
      title: '银行卡详情',
      background: '#F5F6FA',
      customNavBar: true,
    },
    component: () => import('@/views/bankcard/detail/index.vue'),
  },
  /**
   * 宜享花APP银行卡详情页
   * 目前仅用于宜享花APP-变更银行卡预留手机号及解绑银行卡
   */
  {
    path: '/bankcard/detail/:cardId/change-phone',
    meta: {
      title: '修改预留手机号',
      background: '#F5F6FA',
      customNavBar: true,
    },
    component: () => import('@/views/bankcard/detail/change-phone.vue'),
  },
] as RouteConfig[];
